import { useState } from 'react';
import { engineFetchJson } from '@/lib/engineHttp';

const INSTRUCTION = 'send this code to the bot within ten minutes';

interface MintedCode {
  code: string;
  expiresAt: string;
}

function readMint(body: unknown): MintedCode | null {
  if (!body || typeof body !== 'object') return null;
  const record = body as Record<string, unknown>;
  const code = record.code;
  const expiresAt = record.expires_at;
  if (typeof code !== 'string' || code.length === 0) return null;
  if (typeof expiresAt !== 'string' || expiresAt.length === 0) return null;
  return { code, expiresAt };
}

export function TelegramLinkPage() {
  const [mint, setMint] = useState<MintedCode | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function onMint() {
    setPending(true);
    setError(null);
    setMint(null);
    try {
      const body = await engineFetchJson<unknown>('/telegram/account-link/mint', {
        method: 'POST',
      });
      const minted = readMint(body);
      if (!minted) {
        setError('Could not generate a link code.');
        return;
      }
      setMint(minted);
    } catch {
      setMint(null);
      setError('Could not generate a link code.');
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="sp-widget" style={{ maxWidth: 480 }}>
      <div className="sp-widget-header">Link Telegram</div>
      <div className="sp-widget-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <p style={{ margin: 0, color: 'var(--sp-text-muted)' }}>
          Generate a one-time code for the Telegram account you will message the bot from.
        </p>
        <button
          type="button"
          className="sp-btn sp-btn-primary"
          onClick={() => void onMint()}
          disabled={pending}
        >
          {pending ? 'Generating…' : 'Generate a link code'}
        </button>
        {error && (
          <p style={{ margin: 0, color: 'var(--sp-error)' }}>{error}</p>
        )}
        {mint && (
          <div>
            <p className="mono" style={{ margin: '0 0 8px' }}>
              {mint.code}
            </p>
            <p style={{ margin: '0 0 8px' }}>Expires {mint.expiresAt}</p>
            <p style={{ margin: 0 }}>{INSTRUCTION}</p>
          </div>
        )}
      </div>
    </div>
  );
}
